var map = {
	"./virtual-phone/arrow-left.png": "cb88",
	"./virtual-phone/card-bg.png": "a273",
	"./virtual-phone/detect/bg.png": "85dd",
	"./virtual-phone/detect/bg2.png": "27dd",
	"./virtual-phone/detect/btn-animate-start.png": "352e",
	"./virtual-phone/detect/btn-animate-stop.png": "8c98",
	"./virtual-phone/detect/btn-confirm.png": "9a6c",
	"./virtual-phone/detect/btn.png": "0399",
	"./virtual-phone/detect/clock.png": "cade",
	"./virtual-phone/detect/closed.png": "8337",
	"./virtual-phone/detect/detect-report.png": "2632",
	"./virtual-phone/detect/end.png": "2c14",
	"./virtual-phone/detect/focus.png": "5e3f",
	"./virtual-phone/detect/link.png": "028a",
	"./virtual-phone/detect/link2.png": "4ef8",
	"./virtual-phone/detect/mode-deep.png": "25c6",
	"./virtual-phone/detect/mode-plus.png": "3ee6",
	"./virtual-phone/detect/mode-quick.png": "2f03",
	"./virtual-phone/detect/mode-simple.png": "5018",
	"./virtual-phone/detect/start.png": "9daf",
	"./virtual-phone/detect/warning.png": "a3e7",
	"./virtual-phone/tabbar/active-data.png": "efb4",
	"./virtual-phone/tabbar/active-detection.png": "a267",
	"./virtual-phone/tabbar/active-info.png": "568b",
	"./virtual-phone/tabbar/data.png": "d824",
	"./virtual-phone/tabbar/detection.png": "9f28",
	"./virtual-phone/tabbar/info.png": "2920"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "122e";